import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getImagesByCategory } from '../../services/operations/ImageAPI'; // Adjust the path as needed
import { FaArrowAltCircleRight, FaArrowAltCircleLeft, FaWindowClose } from "react-icons/fa";

const CatalogCard = () => {
  const { categoryId } = useParams(); // Extract categoryId from URL
  const [images, setImages] = useState([]);
  const [category, setCategory] = useState({});
  const [currentIndexes, setCurrentIndexes] = useState([0, 0, 0]); // Track current image index for each card
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [modalImage, setModalImage] = useState(null); // Image to be shown in the modal

  useEffect(() => {
    const fetchImages = async () => {
      if (categoryId) {
        const fetchFunction = getImagesByCategory(categoryId);
        const data = await fetchFunction(); // Invoke the function
        if (data && data.success) {
          setImages(data.images || []); // Store all image URLs
          setCategory(data.category || {}); // Set the category details if available
        }
      }
    };

    fetchImages();
  }, [categoryId]);

  // Function to handle next image for each card
  const handleNext = (cardIndex) => {
    setCurrentIndexes((prevIndexes) =>
      prevIndexes.map((index, idx) =>
        idx === cardIndex ? (index === imagesForCard(cardIndex).length - 1 ? 0 : index + 1) : index
      )
    );
  };

  // Function to handle previous image for each card
  const handlePrevious = (cardIndex) => {
    setCurrentIndexes((prevIndexes) =>
      prevIndexes.map((index, idx) =>
        idx === cardIndex ? (index === 0 ? imagesForCard(cardIndex).length - 1 : index - 1) : index
      )
    );
  };

  // Function to group images for each card
  const imagesForCard = (cardIndex) => {
    const chunkSize = Math.ceil(images.length / 3); // Divide images into 3 groups
    return images.slice(cardIndex * chunkSize, (cardIndex + 1) * chunkSize);
  };

  // Function to open the modal with the clicked image
  const openModal = (image) => {
    setModalImage(image); // Set the clicked image for modal display
    setIsModalOpen(true); // Open modal
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false); // Close modal
    setModalImage(null); // Reset modal image
  };

  // Handle case where there are no images
  if (images.length === 0) {
    return <p>No images available for this category.</p>;
  }

  return (
    <div className="mx-auto px-10 sm:px-5"> {/* Adjust padding for smaller screens */}
      {/* Display 3 cards */}
      {[0, 1, 2].map((cardIndex) => (
        <div key={cardIndex} className="lg:h-[20rem] mx-auto rounded overflow-hidden shadow-lg my-4 flex flex-col lg:flex-row"> {/* Flex row for large screens, flex column for small screens */}
          <div className="relative w-full lg:w-1/2"> {/* Full width on mobile, half width on larger screens */}
            {/* Image slider */}
            {imagesForCard(cardIndex).length > 0 && (
              <>
                <img
                  className="w-full h-[15rem] lg:h-[19rem] object-cover cursor-pointer"
                  src={imagesForCard(cardIndex)[currentIndexes[cardIndex]]} // Access the current image for this card
                  alt={`Card ${cardIndex + 1} Slide ${currentIndexes[cardIndex] + 1}`}
                  onClick={() => openModal(imagesForCard(cardIndex)[currentIndexes[cardIndex]])} // Open modal with clicked image
                />
                <button
                  className="absolute top-1/2 left-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full transform -translate-y-1/2 bg-white text-richblack-700 px-2 lg:px-3 py-1"
                  onClick={() => handlePrevious(cardIndex)}
                >
                  <div className="flex items-center justify-center">
                    <FaArrowAltCircleLeft />
                  </div>
                </button>
                <button
                  className="absolute top-1/2 right-0 w-8 h-8 lg:w-10 lg:h-10 rounded-full transform -translate-y-1/2 bg-white text-richblack-700 px-2 lg:px-3 py-1"
                  onClick={() => handleNext(cardIndex)}
                >
                  <div className="flex items-center justify-center">
                    <FaArrowAltCircleRight />
                  </div>
                </button>
              </>
            )}
          </div>
          <div className="w-full lg:w-1/2 px-4 py-4 lg:px-6 lg:py-4 flex flex-col justify-between">
            <div>
              <div className="font-bold text-lg lg:text-xl mb-2 text-richblack-600">{category.name}</div> {/* Adjust font size for smaller screens */}
              <p className="text-richblack-700 text-sm lg:text-base">{category.description}</p> {/* Adjust text size */}
              <div className='mt-5'>
                <span className="inline-block bg-richblack-200 rounded-full px-3 py-1 text-sm font-semibold text-richblack-700 mr-2 mb-2">
                  Category: {category.name || 'N/A'}
                </span>
              </div>
              <div className='mt-6 bg-black p-2 pl-6 text-md lg:text-lg md:text-[1.7rem] text-[0.8rem] flex items-center  rounded-full'>
                <span className='font-bold text-[#D4B42C]'>
                  For Better View Of Mehendi Click the Image
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Modal for full-screen image view */}
      {isModalOpen && modalImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeModal} // Close modal on background click
        >
          <div className="relative" onClick={(e) => e.stopPropagation()}> {/* Stop propagation to avoid closing when clicking on image */}
            {/* Close button */}
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeModal}
            >
              <FaWindowClose />
            </button>

            {/* Display enlarged image */}
            <img
              src={modalImage}
              alt="Enlarged View"
              className="w-[90%] lg:w-[600px] lg:h-[500px] object-contain"
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default CatalogCard;
